import { Component, OnInit } from '@angular/core';
import { NavbarPosition } from './core/api';
import { AuthRepository } from './core/auth';
import { NavBarAction } from './core/models/app';
import { AppCoreService } from './core/services/app-core.service';
import { AppRepository } from './core/state/app.repository';
import { RestaurantsService } from './features/restaurants/state';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  isLoggedIn$ = this.authRepo.isLoggedIn$;
  activeNavBarItemsForNavBar$ = this.appRepo.activeNavBarItemsForNavBar$;
  navBarPlace$ = this.appRepo.navBarPlace$;
  navBarComputed$ = this.appRepo.navBarComputed$;
  hideNavbar? = false;
  NavbarPosition = NavbarPosition;

  constructor(
    private authRepo: AuthRepository,
    private appCoreService: AppCoreService,
    private restaurantsService: RestaurantsService,
    private appRepo: AppRepository,
  ) {}

  async ngOnInit() {
    await this.appCoreService.init();

    this.appCoreService.navigationEndRoute$.subscribe((routeData) => {
      this.hideNavbar = routeData?.data?.hideNavbar;
    });
  }

  async triggerAction(action: NavBarAction) {
    if (action === 'OPEN_SURVEY') {
      await this.restaurantsService.openSurveyCampaignModal({ openCurrentRestaurant: true });
    }
  }
}
